// extracted by mini-css-extract-plugin
module.exports = {"root":"LastMinuteBadge_root__Aj_TZ"};